import { JSONPath } from 'jsonpath-plus';
export var enhanceDynamicData = function (config, dataAPI) {
    var data = JSONPath({
        path: fixOldJsonPath(config.choicesItemPath),
        json: dataAPI,
        flatten: true,
        wrap: false, // the target here is supposed to be an array of items, no need to rewrap it into an array
    });
    return data.map(function (item) {
        var label = item;
        var value = item;
        if (config.choicesItemLabelPath !== '$.') { // prevents issue with "" item
            label = JSONPath({
                path: fixOldJsonPath(config.choicesItemLabelPath),
                json: item,
                wrap: false, // the target here is supposed to be an array of items, no need to rewrap it into an array
            });
        }
        if (config.choicesItemCodePath !== '$.') { // prevents issue with "" item
            value = JSONPath({
                path: fixOldJsonPath(config.choicesItemCodePath),
                json: item,
                wrap: false, // the target here is supposed to be an array of items, no need to rewrap it into an array
            });
        }
        return {
            label: label,
            value: value,
        };
    });
};
/**
 * Old JSON path library was using ".." to target array items.
 */
export var fixOldJsonPath = function (jsonPath) {
    return jsonPath.replace(/\.\./g, '[*].');
};
